import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index.vue'
import category from '../views/category.vue'
import case_content from '../views/case_content.vue'
import add_order from '../views/add_order.vue'
import news from '../views/news.vue'
import news_content from '../views/news_content.vue'
import about_us from '../views/about_us.vue'
import help from '../views/help.vue'
import help_content from '../views/help_content.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: index
  },
  {
    path: '/category',
    name: 'category',
    component: category
  },
  {
    path: '/case_content',
    name: 'case_content',
    component: case_content
  },
  {
    path: '/add_order',
    name: 'add_order',
    component: add_order
  },
  {
    path: '/news',
    name: 'news',
    component: news
  },
  {
    path: '/news_content',
    name: 'news_content',
    component: news_content
  },
  {
    path: '/about_us',
    name: 'about_us',
    component: about_us
  },
  {
    path: '/help',
    name: 'help',
    component: help
  },
  {
    path: '/help_content',
    name: 'help_content',
    component: help_content
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.afterEach(() => {
  window.scrollTo(0,0);
})

export default router
